// initial state
const initial = {
    players: [],
    numberOfPlayers: 5,
    requiredNumOfPlayers: false,
    showInstructions: false,
    teamsPicked: false,
    teamsConfirmed: false,
    team1Players: [],
    team2Players: [],
    team1Colour: "",
    team2Colour: "",
    team1Home: true,
    team1Name: "",
    team2Name: "",
    bookiesFavouriteInfo: {},
    showBookiesFavourite: false,
};

export default initial;